import { render, staticRenderFns } from "./bjxlfx.vue?vue&type=template&id=d1da02d6&scoped=true&"
import script from "./bjxlfx.vue?vue&type=script&lang=js&"
export * from "./bjxlfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1da02d6",
  null
  
)

export default component.exports